import React from 'react'
import { COLUMN_TYPES, Icon, reducers } from '@adc/ui-morpheus'
import { CLIENTS_ROLES } from '../../constants/tableTypes'

const getDefaultProps = width => ({
  width,
  isResizable: true,
  isReorderable: true,
  isVisible: false,
})

export const tableConfig = {
  config: {
    entityKey: CLIENTS_ROLES,
    primaryKeyField: 'id',
  },
  fieldDefinitions: [
    {
      name: 'Selected',
      apiRef: 'selected', // not api val
      columnDefinition: {
        type: COLUMN_TYPES.CHECKBOX,
        colProps: { width: 40, fixed: true },
      },
    },
    {
      name: 'Role',
      apiRef: 'role',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: {
          ...getDefaultProps(100),
          isVisible: true,
          searchable: false,
        },
      },
    },
    {
      name: 'Endpoints',
      apiRef: 'endpoints',
      columnDefinition: {
        type: COLUMN_TYPES.LABEL,
        colProps: {
          ...getDefaultProps(300),
          isVisible: true,
          searchable: false,
        },
      },
    },
    {
      name: 'Edit',
      apiRef: '__actions__', // not api val
      columnDefinition: {
        type: COLUMN_TYPES.ACTION,
        actions: ['Link'],
        colProps: { width: 50, fixedRight: true, align: 'center' },
      },
    },
  ],
}

const columnAction =
  actionCellActionType =>
  (actionIndex, rowIndex, primaryId, data, onRowAction) =>
    (
      <Icon
        color='info'
        size='large'
        style={{ marginTop: -3, cursor: 'pointer' }}
        name='zoom'
        key={actionIndex}
        title='View Details'
        data-elm-id={`action_edit_${rowIndex}`}
        onClick={() => onRowAction(actionCellActionType, rowIndex, primaryId)}
      />
    )

/**
 *
 * @param {*} fieldDefinitions
 * THIS SELECTOR IS TO MAINTAIN BACKWARDS COMPATIBILITY WITH EVERYTHING IN TOOLKIT
 * It will change/ be removed when everything there changes. This is so we can refactor slowly
 */
export const columnSelector = state =>
  state.fieldDefinitions
    .filter(field => field.columnDefinition)
    .map(col => {
      const column = {
        ...col.columnDefinition,
        ...{ field: col.apiRef, title: col.name },
      }
      if (column.actions) column.actions = column.actions.map(columnAction)
      return column
    })

export const getFilterClauses = state => state.filterClauses

export default reducers.dataTable.dataTable(CLIENTS_ROLES, tableConfig)
